// 存放 Vue mixin 可混入的代码
/*
使用说明
接收到数据时，调用了一个离开页面的方法
self.leavePage(obj); //调用离开页面方法;
**/
'use strict'
// import { mapGetters } from "vuex";
export const Websocket = {
  data() {
    return {
      // accountInfo: {}
      wsUrl: '',
      websocket: undefined,
    }
  },
  computed: {
    // ...mapGetters(["accountInfo"])
  },
  mounted() {},
  methods: {
    createWebSocket(wsUrl) {
      let self = this
      if (wsUrl) {
        this.wsUrl = wsUrl
      } else {
        wsUrl = this.wsUrl
      }
      // 与websocket服务器创建连接
      const websocket = new WebSocket(wsUrl)
      this.websocket =websocket
      // 连接成功时
      this.websocket.onopen = () => {
        this.websocket.send('hello')
        console.log('websocket is ok')
      }
      websocket.onmessage = (event) => {
        // 后端发送的消息在event.data中
        if (event.data && event.data !== 'hello' && event.data !== '连接成功') {
          let str = event.data
          try {
            let obj = JSON.parse(str)
            if (typeof obj !== 'object') return
            self.leavePage(obj) //调用离开页面方法;
          } catch (e) {
            console.log(e)
          }
        }
      }
      websocket.onclose = function() {
        console.log('关闭了')
      }
      // 路由跳转时结束websocket链接
      this.$router.afterEach(function() {
        // this.websocket.close()
      })
      // 监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常
      window.onbeforeunload = function() {
        websocket.close()
      }
      // 监听窗口失去焦点事件，主动关闭连接
      // window.onblur = function() {
      //   // websocket.close()
      // }
      // document.removeEventListener('visibilitychange')
      // document.addEventListener('visibilitychange', function() {
      //  let hiden = self.getHiddenProp()
      //  if(hiden){
      //   // websocket.close()
      //  }else{
      //    //重新连接
      //   // this.createWebSocket() 
      //  }
      //   // console.log('hidden',document.hidden )
      //   // console.log('document',document)
      //   // console.log('onblur--------',this.websocket.close())
      //   });
    },
    getHiddenProp() {
      var prefixes = ['webkit', 'moz', 'ms', 'o'];
      // if 'hidden' is natively supported just return it
      if('hidden' in document) return document.hidden;
      
      // otherwise loop over all the known prefixes until we find one
      for(var i = 0; i < prefixes.length; i++) {
      if((prefixes[i] + 'Hidden') in document)
      return document[prefixes[i] + 'Hidden'];
      }
      // otherwise it's not supported
      return null;
      }
  },
  beforeDestroy() {
    if(this.websocket){
      this.websocket.close()
    }
  },
}
